__webpack_require__.p = "https://hra.mikulov.cz/zivotstromu/";